import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
import { Alert, AlertIcon, Text, Link } from '@chakra-ui/core';
import Sparkles from '../../components/Sparkles';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Setup`}</h1>
    <h2>{`User identifier`}</h2>
    <p>{`The user identifier or `}<inlineCode parentName="p">{`userId`}</inlineCode>{` is used to uniquely identify the users in your experiments and feature flags. Any string could be supplied but is recommended to use a uuid.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`userId`}</inlineCode>{` should be persisted somehow. For example, cookies or local storage.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const userId = '676380e0-7793-44d6-9189-eb5868e17a86';
`}</code></pre>
    <h2>{`Settings file`}</h2>
    <p>{`The settings file or  `}<inlineCode parentName="p">{`datafile`}</inlineCode>{` is just a `}<inlineCode parentName="p">{`json`}</inlineCode>{` that defines the configuration of the experiments and features avaliable.`}</p>
    <Alert my={4} status="info" variant="left-accent" overflow="initial" mdxType="Alert">
  <AlertIcon mdxType="AlertIcon" />
  <Text mdxType="Text">This process could be automatically done using our <Link href="https://app.tesfy.io" isExternal mdxType="Link"><Sparkles mdxType="Sparkles">web application</Sparkles></Link> for free!</Text>
    </Alert>
    <p>{`Ideally this file should be hosted somewhere outside your application, so it could be fetched during boostrap or every certain time. This will allow you to make changes to this file without deploying the whole application.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const datafile = {
  experiments: {
    'experiment-1': {
      id: 'experiment-1',
      percentage: 90,
      variations: [{
        id: '0',
        percentage: 50
      }, {
        id: '1',
        percentage: 50
      }]
    },
    'experiment-2': {
      id: 'experiment-2',
      percentage: 100,
      variations: [{
        id: '0',
        percentage: 100
      }],
      audience: { // jsonLogic
        '==' : [{ var : 'countryCode' }, 'us']
      }
    }
  },
  features: {
    'feature-1': {
      id: 'feature-1',
      percentage: 50
    }
  }
};
`}</code></pre>
    <p>{`The format to define audiences is `}<a parentName="p" {...{
        "href": "http://jsonlogic.com/"
      }}>{`jsonLogic`}</a>{` which allow you to build complex rules as JSON. For example, you can nest rules to target users that are older than 32 years old and are located in 🇻🇪.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const rules = {
  and: [
    { '<': [{ var: 'age' }, 32] },
    { '==': [{ var: 'countryCode' }, 've'] }
  ]
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      